import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";

interface IFileTypeGrowthCurve extends IExportableFile {
    PatientContactId: string;
    fileType: FileType;
}

class FileTypeGrowthCurve extends ExportableFile implements IFileTypeGrowthCurve {
    public PatientContactId: string;

    constructor(fields: IFileTypeGrowthCurve) {
        super(fields.fileType);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.PatientContactId; }

    public getCleanCopy(): FileTypeGrowthCurve {
        let copyConstructor: IFileTypeGrowthCurve = {
            PatientContactId: this.PatientContactId,
            fileType: this.fileType,
            date: this.date,
            description: this.description
        };

        return new FileTypeGrowthCurve(copyConstructor);
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected generateFileIfNeeded(): Promise<IExportableFileLoaded> {
        const fetchUrl = FileSelectionHelper.getFetchUrl(this.PatientContactId, this.fileType, { noCache: true });

        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: fetchUrl
        }));
    }
}

export { FileTypeGrowthCurve };
